module.exports = __webpack_public_path__ + "static/scale-model-of-mcdowell-grove-in-aurora-illinois-8cb2da14212bb47fd211c48d2192acdc.png";